import React, { useState, useContext } from "react";
import { UserInformationContext, AdminUserInformationContext } from "../main/App";
import { C4FStatusContext } from "../main/App";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button, ButtonGroup, Form, Alert, Container, Table, InputGroup } from 'react-bootstrap';
import Chart from "react-apexcharts";
import '../css/general.css';
import C4FSimpleTable from "../common/C4FSimpleTable";
import C4FInfoModal from "../common/C4FInfoModal";
import C4FInfoButton from "../common/C4FInfoButton";
import { movingAverage } from "../common/Helpers";

function Admin(props) {

  const { userInformation, setUserInformation } = useContext(UserInformationContext);
  const { setAdminUserInformation } = useContext(AdminUserInformationContext);
  const { handleBackendRequest, handleBackendScript } = useContext(C4FStatusContext);
  const navigate = useNavigate();
  const [tab, setTab] = useState('enterAccount');
  const [reportTab, setReportTab] = useState('totalUsers');
  const [scriptTab, setScriptTab] = useState('scriptLog');
  const [userName, setUserName] = useState('');
  const [user, setUser] = useState(null);
  const [enterAccountInfo, setEnterAccountInfo] = useState('');
  const [newsList, setNewsList] = useState(null);
  const [newsEntryId, setNewsEntryId] = useState('');
  const [newsEntryDate, setNewsEntryDate] = useState('');
  const [newsEntryMessage, setNewsEntryMessage] = useState('');
  const [saveNewsMessage, setSaveNewsMessage] = useState('');
  const [scriptLog, setScriptLog] = useState([]);
  const [userStatistics, setUserStatistics] = useState([]);
  const [userStatsType, setUserStatsType] = useState('list');
  const [logins, setLogins] = useState([]);
  const [cronjobs, setCronjobs] = useState([]);
  const [selectedCronjob, setSelectedCronjob] = useState(null);
  const [processingLocks, setProcessingLocks] = useState([]);
  const [scriptOutput, setScriptOutput] = useState(null);
  const [showScriptOutput, setShowScriptOutput] = useState(false);
  const [scriptToExecuteName, setScriptToExecuteName] = useState('');
  const [scriptToExecuteParameters, setScriptToExecuteParameters] = useState('');
  const [dryRun, setDryRun] = useState(false);
  const [scriptFilter, setScriptFilter] = useState([]);
  const [scriptFilterName, setScriptFilterName] = useState('all');
  const [scriptResult, setScriptResult] = useState(null);
  const handleCloseScriptOutput = () => setShowScriptOutput(false);

  function enterAccount() {
    setAdminUserInformation(userInformation);
    setUserInformation(user);
    navigate('/home');
  }

  function handleShowScriptLogDetails(scriptLogRecord) {
    handleBackendRequest('GET', '/script/' + scriptLogRecord.id, null, null,
      function (result) {
        if (result.scriptOutput) {
          setShowScriptOutput(true);
          setScriptOutput(result.scriptOutput);
        }
      });
  }

  function loadStatistics(type, mode = 'default') {
    let url = null;
    let pageSize = 0;
    switch (type) {
      case 'totalUsers': url = '/statistics/' + type; pageSize = mode === 'default' ? 100 : 1000; break;
      case 'logins': url = '/statistics/' + type; break;
      case 'cronjob': case 'processingLock': url = '/admin/' + type; break;
      case 'scriptLog': url = '/script'; break;
      default: url = 'undefined';
    }

    let params = pageSize > 0 ? { pageSize: pageSize } : null;

    handleBackendRequest('GET', url, null, params,
      function (result) {
        if (type === 'scriptLog') setScriptLog(result);
        if (type === 'totalUsers') setUserStatistics(enrichUserStatistics(result));
        if (type === 'logins') setLogins(result);
        if (type === 'cronjob') setCronjobs(result);
        if (type === 'processingLock') setProcessingLocks(result);
      });

  }

  function enrichUserStatistics(userStatistics) {
    return userStatistics.map(us => ({
      ...us,
      teamsPerOneDayRace: us.oneDayRaces > 0 ? us.teamsOneDayRaces / us.oneDayRaces : 0,
      ridersPerOneDayRace: us.oneDayRaces > 0 ? us.ridersOneDayRaces / us.oneDayRaces : 0,
      teamsPerTour: us.tours > 0 ? us.teamsTours / us.tours : 0,
      ridersPerTour: us.tours > 0 ? us.ridersTours / us.tours : 0,
      races: us.oneDayRaces + us.tours,
      teamsRaces: us.teamsOneDayRaces + us.teamsTours,
      ridersRaces: us.ridersOneDayRaces + us.ridersTours,
      teamsPerRace: us.oneDayRaces + us.tours > 0 ? (us.teamsOneDayRaces + us.teamsTours) / (us.oneDayRaces + us.tours) : 0,
      ridersPerRace: us.oneDayRaces + us.tours > 0 ? (us.ridersOneDayRaces + us.ridersTours) / (us.oneDayRaces + us.tours) : 0,      
    })).reverse();
  }

  function handleNews() {
    handleBackendRequest('GET', '/generalInformation/news', null, null,
      function (news) {
        setNewsList(news);
        setNewsEntryId(null);
        setNewsEntryDate(null);
        setNewsEntryMessage(null);
        setTab('news');
      });

  }

  function handleNewsEntry(newsEntry) {
    let selectedNewsEntry = newsList.find(ne => ne.id === newsEntry.id);
    setNewsEntryId(selectedNewsEntry.id);
    setNewsEntryDate(selectedNewsEntry.date);
    setNewsEntryMessage(selectedNewsEntry.message);
    setTab('newsEntry');
  }

  function saveNewsEntry(id) {
    if (newsEntryId === null || newsEntryId.length === 0)
      handleBackendRequest('POST', '/generalInformation/news',
        {
          date: newsEntryDate,
          message: newsEntryMessage
        },
        null,
        function (news) {
          setNewsEntryId(news.id);
          setSaveNewsMessage('News saved');
        });
    else
      handleBackendRequest('PATCH', '/generalInformation/news',
        {
          id: newsEntryId,
          date: newsEntryDate,
          message: newsEntryMessage
        },
        null,
        function (news) {
          setNewsEntryId(news.id);
          setSaveNewsMessage('News saved');
        });
  }

  function loadUser() {
    handleBackendRequest('GET', '/user/' + userName, null, null,
      function (user) {
        setUser(user);
        setEnterAccountInfo('User ' + user.userName + ' loaded.');
      });
  }

  function handleCronjobRunNow() {
    setScriptToExecuteName(selectedCronjob.scriptName);
    setScriptToExecuteParameters(selectedCronjob.parameters);
    setScriptTab('scriptExecution');
  }

  function executeScript() {
    let params = { script: scriptToExecuteName, isDryRun: dryRun };
    let additionalParams = scriptToExecuteParameters.split('&');
    additionalParams.forEach(p => {
      let parameter = p.split('=');
      if (parameter.constructor === Array && parameter.length === 2 && parameter[0].length > 0)
        params[parameter[0]] = parameter[1];
    })
    handleBackendScript('POST', '/ScriptRunner.php', params, function (result) {
      setScriptResult(result.data);
    })
  }

  function handleScriptLogFilter(filter) {
    if (filter === 'user') setScriptFilter([{
      columnName: 'triggeredBy',
      type: 'text',
      value: '^(?!(cronjob))',
      regex: '^(?!(cronjob))',
      valid: true
    }]);
    else if (filter === 'rare') setScriptFilter([{
      columnName: 'name',
      type: 'text',
      value: '^(?!(RaceCalculation|ProcessTransfermarket))',
      regex: '^(?!(RaceCalculation|ProcessTransfermarket))',
      valid: true
    }]);
    else if (filter === 'long') setScriptFilter([{
      columnName: 'duration',
      type: 'text',
      value: 'Des|Rev',
      regex: 'Des|Rev',
      valid: true
    }]);
    else if (filter === 'error') setScriptFilter([{
      columnName: 'result',
      type: 'text',
      value: '^(?!(OK))',
      regex: '^(?!(OK))',
      valid: true
    }]);
    else setScriptFilter([]);
    setScriptFilterName(filter);
  }

  function handleSetTab(tab) {
    if (tab === 'scripts') {
      handleScriptTab(scriptTab);
    }
    if (tab === 'reports') {
      handleReportTab(reportTab);
    }
    setTab(tab);
  }

  function handleScriptTab(newScriptTab) {
    if (newScriptTab === 'scriptLog') {
      if (scriptLog.length === 0)
        loadStatistics('scriptLog');
      handleScriptLogFilter('all');
    }
    if ((newScriptTab === 'cronjobs')
      && cronjobs.length === 0) {
      loadStatistics('cronjob');
    }
    setScriptTab(newScriptTab);
  }

  function handleReportTab(newReportTab) {
    if ((newReportTab === 'totalUsers')
      && userStatistics.length === 0) {
      loadStatistics('totalUsers');
    }
    if ((newReportTab === 'logins')
      && logins.length === 0) {
      loadStatistics('logins');
    }
    if ((newReportTab === 'processingLocks')
      && processingLocks.length === 0) {
      loadStatistics('processingLock');
    }
    setReportTab(newReportTab);
  }

  if (!userInformation.roles.includes('Admin'))
    return <div>Admin area only</div>;
  else
    if (userInformation !== null)
      return <Container fluid className="m-1">
        <C4FInfoModal key={'scriptOutput'} show={showScriptOutput}
          title={'Script Output'}
          info={scriptOutput}
          handleClose={handleCloseScriptOutput}
          type={'preformatted'} size={'xl'}
        />
        <Row className="justify-content-center my-1">
          <Col className="">
            <ButtonGroup>
              <Button variant={(tab === 'scripts') ? 'primary' : 'outline-primary'} onClick={() => handleSetTab('scripts')}>Backend Scripts</Button>
              <Button variant={(tab === 'news') ? 'primary' : 'outline-primary'} onClick={() => handleNews()}>All News</Button>
              <Button variant={(tab === 'newsEntry') ? 'primary' : 'outline-primary'} onClick={() => handleSetTab('newsEntry')}>Add / Change News</Button>
              <Button variant={(tab === 'enterAccount') ? 'primary' : 'outline-primary'} onClick={() => handleSetTab('enterAccount')}>Enter Account</Button>
              <Button variant={(tab === 'reports') ? 'primary' : 'outline-primary'} onClick={() => handleSetTab('reports')}>Reports</Button>
              {/* <Button variant={(tab === 'userManagement') ? 'primary' : 'outline-primary'} onClick={() => setTab('userManagement')} disabled>User Management</Button>
              <Button variant={(tab === 'serverManagement') ? 'primary' : 'outline-primary'} onClick={() => setTab('serverManagement')} disabled>Server Management</Button> */}
            </ButtonGroup>
          </Col>
        </Row>
        {tab === 'scripts' ?
          <>
            <Row >
              <Col>
                <h3 className="mt-1">Backend Script Handling</h3>
              </Col>
            </Row>
            <Row className="d-flex mt-1 p-1 justify-content-center">
              <Col>
                <ButtonGroup size="sm">
                  <Button variant={(scriptTab === 'cronjobs') ? 'primary' : 'outline-primary'} onClick={() => handleScriptTab('cronjobs')}>Cronjobs</Button>
                  <Button variant={(scriptTab === 'scriptExecution') ? 'primary' : 'outline-primary'} onClick={() => handleScriptTab('scriptExecution')}>Script Execution</Button>
                  <Button variant={(scriptTab === 'scriptLog') ? 'primary' : 'outline-primary'} onClick={() => handleScriptTab('scriptLog')}>Script Log</Button>
                </ButtonGroup>
              </Col>
            </Row>
            <Row className="d-flex mt-1 p-1 justify-content-center">
              <Col>
                {scriptTab === 'cronjobs' ?
                  <>
                    <Container className="m-0 p-0" style={{ maxHeight: 300, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                      <C4FSimpleTable
                        key={'cronjobs'}
                        data={cronjobs}
                        initialSortingColumn={'nextExecution'}
                        initialSortingAscending={true}
                        highlightCriteriaKey={'name'}
                        highlightCriteriaValue={selectedCronjob !== null ? selectedCronjob.name : null}
                        rowMetadata={[
                          { columnName: 'name', columnDescription: 'Name', cellClickEvent: setSelectedCronjob },
                          { columnName: 'scriptName', columnDescription: 'Script', cellClickEvent: setSelectedCronjob },
                          { columnName: 'priority', columnDescription: 'Priority' },
                          { columnName: 'nextExecution', columnDescription: 'Next Execution' }
                        ]}
                      />
                    </Container>
                    {selectedCronjob ?
                      <Container className="py-1">
                        <Table striped size="sm">
                          <tbody>
                            <tr>
                              <td><b>Name</b></td>
                              <td>
                                {selectedCronjob.name}
                                <Button className="mx-1" size="sm" variant="success" onClick={() => handleCronjobRunNow()}>Run Now</Button>
                              </td>
                            </tr>
                            <tr>
                              <td><b>Script Name</b></td>
                              <td>{selectedCronjob.scriptName}</td>
                            </tr>
                            {selectedCronjob.parameters && selectedCronjob.parameters.length > 0 ?
                              <tr>
                                <td><b>Parameters</b></td>
                                <td>{selectedCronjob.parameters}</td>
                              </tr>
                              : null}
                            <tr>
                              <td><b>Description</b></td>
                              <td>{selectedCronjob.description}</td>
                            </tr>
                            <tr>
                              <td><b>Priority</b></td>
                              <td>{selectedCronjob.priority}</td>
                            </tr>
                            <tr>
                              <td><b>Next Execution</b></td>
                              <td>{selectedCronjob.nextExecution}</td>
                            </tr>
                            <tr>
                              <td><b>Locked Tables</b></td>
                              <td>{selectedCronjob.lockedTables}</td>
                            </tr>
                            <tr>
                              <td><b>Execution Schedule</b></td>
                              <td>
                                Days: {selectedCronjob.includeDay}<br></br>
                                Hours: {selectedCronjob.includeHour}<br></br>
                                Minutes: {selectedCronjob.includeMinute}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Container>
                      : null}
                  </>
                  : null}
                {scriptTab === 'scriptExecution' ?
                  <>
                    <Row>
                      <Col className="col-4">
                        <InputGroup size="sm" className="">
                          <C4FInfoButton size="sm" title={'Script Name'} text={'(file) name of the script to be executed, base path is the backend/background directory'} />
                          <Form.Control disabled type={'text'} value={'script name'} />
                          <Form.Control
                            type={'text'} value={scriptToExecuteName}
                            onChange={(e) => setScriptToExecuteName(e.target.value)} />
                        </InputGroup>
                      </Col>
                      <Col className="col-4">
                        <InputGroup size="sm" className="">
                          <C4FInfoButton size="sm" title={'Script Parameters'} text={'http query parameters of script'} />
                          <Form.Control disabled type={'text'} value={'script parameters'} />
                          <Form.Control
                            type={'text'} value={scriptToExecuteParameters}
                            onChange={(e) => setScriptToExecuteParameters(e.target.value)} />
                        </InputGroup>
                      </Col>
                      <Col className="col-2">
                        <InputGroup size="sm" className="">
                          <Form.Check value={dryRun} onChange={(e) => {console.log(e);setDryRun(e.target.checked)} } />
                          <Form.Control disabled type={'text'} value={'dry run ' + (dryRun ? 'enabled' : 'disabled')} />
                        </InputGroup>
                      </Col>
                      <Col className="col-2">
                        <Button className="" size="sm" variant="success" onClick={() => executeScript()}>Run Now</Button>
                      </Col>
                    </Row>
                    {scriptResult ?
                      <Row className="mt-2">
                        <Col>
                          <pre>
                            {scriptResult}
                          </pre>
                        </Col>
                      </Row>
                      : null}
                  </>
                  : null}
                {scriptTab === 'scriptLog' ?
                  <>
                    <Row>
                      <Col>
                        <ButtonGroup>
                          <Button size="sm" variant={(scriptFilterName !== 'all' ? 'outline-' : '') + 'secondary'}
                            onClick={() => handleScriptLogFilter('all')}>All</Button>
                          <Button size="sm" variant={(scriptFilterName !== 'rare' ? 'outline-' : '') + 'secondary'}
                            onClick={() => handleScriptLogFilter('rare')}>Rarely Run</Button>
                          <Button size="sm" variant={(scriptFilterName !== 'error' ? 'outline-' : '') + 'secondary'}
                            onClick={() => handleScriptLogFilter('error')}>With Error</Button>
                          <Button size="sm" variant={(scriptFilterName !== 'long' ? 'outline-' : '') + 'secondary'}
                            onClick={() => handleScriptLogFilter('long')}>Long Running</Button>
                          <Button size="sm" variant={(scriptFilterName !== 'user' ? 'outline-' : '') + 'secondary'}
                            onClick={() => handleScriptLogFilter('user')}>User-Initiated</Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                    <Container className="mt-1 p-0" style={{ maxHeight: 800, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                      <C4FSimpleTable
                        key={'scriptLog'}
                        data={scriptLog}
                        initialSortingColumn={'date'}
                        initialSortingAscending={false}
                        filters={scriptFilter}
                        refreshTable={() => loadStatistics('scriptLog')}
                        rowMetadata={[
                          { columnName: 'date', columnDescription: 'Date' },
                          { columnName: 'host', columnDescription: 'Host' },
                          { columnName: 'name', columnDescription: 'Name', cellClickEvent: handleShowScriptLogDetails },
                          { columnName: 'triggeredBy', columnDescription: 'Triggered By' },
                          { columnName: 'duration', columnDescription: 'Duration' },
                          { columnName: 'result', columnDescription: 'Result' }
                        ]}
                      />
                    </Container>
                  </>
                  : null}
              </Col>
            </Row>
          </>
          : null}
        {tab === 'enterAccount' ?
          (<Row >
            <Col className="col-3"></Col>
            <Col className="col-6">
              <h3 className="mt-1">User Search</h3>
              <div className="mt-1 mb-1">
                <Form.Label>User Name (exact match)</Form.Label>
                <Form.Control type="text"
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="team name"
                  value={userName} />
                <Button variant="primary" className="m-2" onClick={() => loadUser()}>Search</Button>
              </div>
              <Alert key="alertEnterAccount" variant={'warning'}>{enterAccountInfo}</Alert>
              {(user !== null) ? (
                <Button variant="primary" className="m-2" onClick={() => enterAccount()}>Enter {user.userName}</Button>
              ) : null}

            </Col>
            <Col className="col-3"></Col>
          </Row>) : null
        }
        {(tab === 'news' && newsList !== null) ?
          (<Row className="justify-content-center">
            <Col>
              <h3 className="mt-1">All News</h3>
              <C4FSimpleTable
                hideFilterButtons={true}
                hideColumnVisibility={true}
                data={newsList.map(n => ({
                  ...n,
                  messageFormatted: <p>{n.message}</p>
                }))}
                rowMetadata={[
                  { columnName: 'date', columnDescription: 'Date', cellClickEvent: handleNewsEntry },
                  { columnName: 'messageFormatted', columnDescription: 'Message', columnType: 'object' }
                ]}
              />
            </Col>
          </Row>) : null
        }
        {(tab === 'newsEntry') ?
          (<Row className="justify-content-center">
            <Col>
              <h3 className="mt-1">News Entry</h3>
              <div className="mt-1 mb-1">
                <Form.Label>ID</Form.Label>
                <Form.Control type="text" disabled
                  value={newsEntryId} />
                <Form.Label>Date</Form.Label>
                <Form.Control type="date"
                  onChange={(e) => setNewsEntryDate(e.target.value)}
                  placeholder="date"
                  value={newsEntryDate} />
                <Form.Label>Message</Form.Label>
                <Form.Control type="text"
                  onChange={(e) => setNewsEntryMessage(e.target.value)}
                  placeholder="message"
                  value={newsEntryMessage} />
                <Button variant="primary" className="m-2" onClick={() => saveNewsEntry()}>Save</Button>
                <Alert key="alertSaveNews" variant={'warning'}>{saveNewsMessage}</Alert>
              </div>
            </Col>
          </Row>) : null
        }
        {(tab === 'reports') ?
          // <Container className="container-fluid m-0 p-0 justify-content-center">
          <>
            <Row className="row d-flex mt-1 p-1">
              <h3>Reports</h3>
            </Row>
            <Row className="d-flex mt-1 p-1 justify-content-center">
              <ButtonGroup>
                <Button variant={(reportTab === 'totalUsers') ? 'primary' : 'outline-primary'} onClick={() => handleReportTab('totalUsers')}>User Statistics</Button>
                <Button variant={(reportTab === 'logins') ? 'primary' : 'outline-primary'} onClick={() => handleReportTab('logins')}>Logins</Button>
                <Button variant={(reportTab === 'processingLocks') ? 'primary' : 'outline-primary'} onClick={() => handleReportTab('processingLocks')}>Locks</Button>
              </ButtonGroup>
            </Row>
            <Row className="d-flex mt-1 p-1 justify-content-center">
              <Col className="ml-2 mr-1 my-1 p-0" style={{ minWidth: 400, maxWidth: "80vw" }}>
                {reportTab === 'totalUsers' ?
                  <>
                    <h5>User Statistics</h5>
                    <Button className="my-1" size="sm" variant={'primary'} onClick={() => loadStatistics('totalUsers', 'more')}>Load more</Button>                    
                    <ButtonGroup className="mx-1">
                      <Button className="my-1" size="sm" variant={(userStatsType !== 'list' ? 'outline-' : '') + 'primary'} 
                        onClick={() => setUserStatsType('list')}>List</Button>
                      <Button className="my-1" size="sm" variant={(userStatsType !== 'graph' ? 'outline-' : '') + 'primary'} 
                        onClick={() => setUserStatsType('graph')}>Graph</Button>
                    </ButtonGroup>
                    <Container className="m-0 p-0" style={{ maxHeight: 800, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                      {userStatsType === 'list' ? 
                        <C4FSimpleTable
                          initialSortingColumn={'reportDate'}
                          initialSortingAscending={false}                        
                          key={'userStatistics'}
                          data={userStatistics}
                          rowMetadata={[
                            { columnName: 'reportDate', columnDescription: 'Date', columnGroup: 'Overview' },
                            { columnName: 'teamsWithRiders', columnDescription: 'Teams w/ Riders', columnGroup: 'Overview' },
                            { columnName: 'teamsWithPoints', columnDescription: 'Teams w/ Points', columnGroup: 'Overview' },
                            { columnName: 'usersWithLogin', columnDescription: 'Users Login', columnGroup: 'Overview' },
                            { columnName: 'races', columnDescription: 'Races', columnGroup: 'All Races' },
                            { columnName: 'teamsRaces', columnDescription: '\u03A3 Teams', columnGroup: 'All Races' },
                            { columnName: 'teamsPerRace', columnDescription: '\u2300 Teams', columnGroup: 'All Races' },
                            { columnName: 'ridersRaces', columnDescription: '\u03A3 Riders', columnGroup: 'All Races' },
                            { columnName: 'ridersPerRace', columnDescription: '\u2300 Riders', columnGroup: 'All Races' },
                            { columnName: 'oneDayRaces', columnDescription: 'Races', columnGroup: 'One-Day Races' },
                            { columnName: 'teamsOneDayRaces', columnDescription: '\u03A3 Teams', columnGroup: 'One-Day Races' },
                            { columnName: 'teamsPerOneDayRace', columnDescription: '\u2300 Teams', columnGroup: 'One-Day Races' },
                            { columnName: 'ridersOneDayRaces', columnDescription: ' \u03A3 Riders', columnGroup: 'One-Day Races' },
                            { columnName: 'ridersPerOneDayRace', columnDescription: '\u2300 Riders', columnGroup: 'One-Day Races' },
                            { columnName: 'tours', columnDescription: 'Races', columnGroup: 'Tours' },
                            { columnName: 'teamsTours', columnDescription: '\u03A3 Teams', columnGroup: 'Tours' },
                            { columnName: 'teamsPerTour', columnDescription: '\u2300 Teams', columnGroup: 'Tours' },
                            { columnName: 'ridersTours', columnDescription: ' \u03A3 Riders', columnGroup: 'Tours' },
                            { columnName: 'ridersPerTour', columnDescription: '\u2300 Riders', columnGroup: 'Tours' }
                          ]}
                        />
                        :
                        <Chart type="area" options={{
                            xaxis: { categories: userStatistics.map(us => us.reportDate) },
                            dataLabels: { enabled: false },
                            stroke: { width: 1 },
                            yaxis: [
                              {
                                labels: {
                                  formatter: function(val) {
                                    return isNaN(val) ? 0 : val.toFixed(0);
                                  }
                                }
                              }
                            ]
                          }}
                          series={[
                              { 
                                name: '\u03A3 Teams',
                                data: userStatistics.map(us => us.teamsRaces)
                              },
                              { 
                                name: '\u03A3 Teams Avg',
                                data: movingAverage(userStatistics.map(us => us.teamsRaces), 7)
                              },
                              { 
                                name: 'Users Login',
                                data: userStatistics.map(us => us.usersWithLogin)
                              },
                              { 
                                name: 'Users Login Avg',
                                data: movingAverage(userStatistics.map(us => us.usersWithLogin), 7)
                              }
                            ]
                          }
                        />
                      }
                    </Container>
                  </>
                  : null}
                {reportTab === 'logins' ?
                  <>
                    <h5>Logins</h5>
                    <Container className="m-0 p-0" style={{ maxHeight: 800, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                      <C4FSimpleTable
                        key={'logins'}
                        data={logins}
                        rowMetadata={[
                          { columnName: 'userId', columnDescription: 'UserID' },
                          { columnName: 'userName', columnDescription: 'User' },
                          { columnName: 'ip', columnDescription: 'IP' },
                          { columnName: 'loginTime', columnDescription: 'Time' },
                          { columnName: 'version', columnDescription: 'Version' },
                          { columnName: 'userAgent', columnDescription: 'User Agent' }
                        ]}
                      />
                    </Container>
                  </>
                  : null}
                {reportTab === 'processingLocks' ?
                  <>
                    <h5>Processing Locks</h5>
                    <Container className="m-0 p-0" style={{ maxHeight: 800, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                      <C4FSimpleTable
                        key={'processingLocks'}
                        data={processingLocks}
                        rowMetadata={[
                          { columnName: 'lockId', columnDescription: 'Name' },
                          { columnName: 'tableName', columnDescription: 'Table' },
                          { columnName: 'status', columnDescription: 'Status' },
                          { columnName: 'lockedTables', columnDescription: 'Locked Tables' },
                          { columnName: 'startTime', columnDescription: 'Start' },
                          { columnName: 'endTime', columnDescription: 'End' }
                        ]}
                      />
                    </Container>
                  </>
                  : null}
              </Col>
            </Row>
          </>
          // </Container> 
          : null}
        <Row className="justify-content-center my-1">
          <Col>
            <Alert key="alertAdminArea" variant={'danger'}>Admin Area - Handle with care!</Alert>
          </Col>
        </Row>
      </Container>;
    else return null;
}

export default Admin;